import EditOutlinedIcon from '@material-ui/icons/EditOutlined';
import React from 'react';
import styled, { css } from 'styled-components/macro';
import { iconButtonStyles } from '../../common/elements/Button';
import {
  fontSize,
  fontWeight,
  lineHeight,
  media,
  neutral,
  space,
} from '../../../theme/tokens';
import * as StaffCommon from '../../common/elements/Staff';

export const StaffTopicSubHeader = styled(StaffCommon.StaffSubHeader).attrs({
  as: 'h3',
})`
  padding: 0;
  font-size: ${fontSize.lg};
  color: ${({ theme }) => theme.headerColour};
  overflow-wrap: anywhere;
`;

export const Inline = styled.div`
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: ${space[3]};
  min-width: 0;
`;

export const CardList = styled(StaffCommon.StaffCardGrid)``;

export const FilterTopicsForm = styled.form`
  width: 100%;
  max-width: 100%;

  & .MuiFormControl-root {
    width: 100%;
  }

  ${media.md`
    width: auto;

    & .MuiFormControl-root {
      width: auto;
    }
  `}
`;

export const ActiveTopic = styled(StaffCommon.StatusChip)``;

export const EditTopicButton = styled.button`
  ${iconButtonStyles}
`;

export const EditIcon = (props) => {
  return <EditOutlinedIcon {...props} style={{ fontSize: fontSize.xl }} />;
};

export const SubjectHeader = styled.h2`
  margin: ${space[5]} 0 ${space[2]};
  color: ${({ theme }) => theme.headerColour};
  font-weight: ${fontWeight.bold};
  font-size: ${fontSize.xl};
  line-height: ${lineHeight.tight};
  overflow-wrap: anywhere;
`;

export const SubjectContainer = styled.section`
  display: flex;
  flex-direction: column;
  gap: ${space[3]};
  padding-bottom: ${space[3]};
  ${({ isLastInSubject }) =>
    isLastInSubject &&
    css`
      border-bottom: 1px solid ${neutral.border};
      padding-bottom: ${space[5]};
    `}
`;

export const PageHeader = styled.header`
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  justify-content: space-between;
  gap: ${space[4]};
`;

export const TopicHeaderRow = styled.div`
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  justify-content: space-between;
  gap: ${space[2]} ${space[4]};
`;

export const TopicTitleGroup = styled.div`
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: ${space[2]} ${space[3]};
  min-width: 0;
  padding-left: ${space[3]};
  border-left: 4px solid ${({ theme }) => theme.classroomHighlight};
  border-radius: 2px;
`;

export const TopicActions = styled.div`
  display: flex;
  align-items: center;
  gap: ${space[1]};
  margin-left: auto;
`;

export * from '../../common/elements/Form';
export * from '../../common/elements/Staff';
